export const appName = 'Your AI'
export const supportEmail = 'hello@alreadyknowsyou.com'
export const stripeCheckoutUrl =
	'https://buy.stripe.com/bJeeVd9PLbo17474KD6sw0d'
export const workshopPrice = '30€'
